import React from 'react';
import { menu } from '@stereoagency/sanity-schema';
import { MenuLocation, defaultLanguage } from '@stereoagency/constants';
import UINavbar from './Navbar.client';
import { $globalSanityClient } from '@/sanity';
import { waterfallFetch } from '@/utils';

type Props = {
  lang: string;
};

const menuQuery = menu.schema.builder
  .filter('language == $language && location == $location')
  .first()
  .use();
type MenuQueryType = (typeof menuQuery)[1] | null;

export default async function Navbar({ lang }: Props) {
  const primaryMenu = await waterfallFetch(
    [lang, defaultLanguage.id],
    (current) =>
      $globalSanityClient.fetch<MenuQueryType>(menuQuery[0], {
        language: current,
        location: MenuLocation.PRIMARY
      })
  );

  const actionsMenu = await waterfallFetch(
    [lang, defaultLanguage.id],
    (current) =>
      $globalSanityClient.fetch<MenuQueryType>(menuQuery[0], {
        language: current,
        location: MenuLocation.ACTIONS
      })
  );

  const secondaryMenu = await waterfallFetch(
    [lang, defaultLanguage.id],
    (current) =>
      $globalSanityClient.fetch<MenuQueryType>(menuQuery[0], {
        language: current,
        location: MenuLocation.SECONDARY
      })
  );

  return (
    <UINavbar
      key="navbar"
      lang={lang}
      actionsMenu={actionsMenu}
      primaryMenu={primaryMenu}
      secondaryMenu={secondaryMenu}
    />
  );
}
